import { AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'

import reportsUrls from '../../utils/urls/reportsUrls'
import eventsUrls from '../../utils/urls/eventsUrls'
import { eventTypes } from '../../components/CaseTimeline/types'

/* 
Endpoint: /reports/{id}/events
Returns: events for given report ID
*/
const getEvents = (id: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${reportsUrls.getReportById(id)}events`)

/* 
Endpoint: /events/{id}/content?type={type}
Returns: Content for given event ID
*/
const getContent = (id: number, type: eventTypes) =>
  axiosInstance.get(`${eventsUrls.eventById(id)}/content`, { params: { type: type } })

const filterEvents = (filter: any) =>
  axiosInstance.get(`${eventsUrls.events()}`, { params: { ...filter } })

export default { getEvents, getContent, filterEvents }
